module.exports = __webpack_public_path__ + "media/src/fonts/roboto-mono/roboto-mono-500-medium-9d84bebf5f20aa2dae0b64463b8978b6.woff2";